import EventEdit from './EventEdit';
import EventList from './EventList';
import EventShow from './EventShow';

export default {
  list: EventList,
  edit: EventEdit,
  show: EventShow,
};
